/**
 * Merges read-only prop from ServiceRequestFlow with injected flow flag.
 */
export default {
  inject: {
    serviceRequestFlowReadOnly: {
      default: () => false
    }
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    viewOnly() {
      const injected =
        typeof this.serviceRequestFlowReadOnly === "function"
          ? this.serviceRequestFlowReadOnly()
          : this.serviceRequestFlowReadOnly;
      return Boolean(this.readOnly || injected);
    }
  }
};
